import { createNullCache } from '@algolia/cache-common';
import { IProductModel } from '@masterofmalt/atom.componentlibrary/models/internal/product/IProductModel';
import { liteClient as algoliasearch, SearchParamsObject } from 'algoliasearch/lite';

import { env } from '~/lib/atom/env';
import { ActivePromotion } from '~/lib/atom/types/active-promotion';
import { PriceConfig } from '~/lib/atom/types/price-config';

import { mapToIProductModel } from './map-to-product-model';
import { algoliaFieldNames } from './schema';

const searchClient = algoliasearch(
  env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  env.NEXT_PUBLIC_ALGOLIA_PUBLIC_KEY,
  {
    // We're going to rely on the DataLoader to cache results.
    responsesCache: createNullCache(),
    requestsCache: createNullCache(),
  },
);

export const getProducts = async (
  { filters, hitsPerPage }: SearchParamsObject,
  priceConfig: PriceConfig,
  promotions: ActivePromotion[],
  indexName: string = env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME,
): Promise<IProductModel[]> => {
  const attributesToRetrieve = Object.values(algoliaFieldNames).map((value) => {
    return typeof value === 'function' ? value(priceConfig) : value;
  });

  const response = await searchClient.searchForHits<unknown>([
    {
      indexName,
      params: {
        hitsPerPage,
        filters,
        attributesToRetrieve,
      },
    },
  ]);

  if (!response.results[0] || response.results[0].hits.length === 0) {
    return [];
  }

  return response.results[0].hits.map((hit) => mapToIProductModel(hit, priceConfig, promotions));
};
